import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { toast } from "sonner";
import { SIcon } from "../../components";
const actionIconMap = {
    "open-url": "open",
    close: "x",
    restore: "refresh",
    "custom-in-app": "play",
    "custom-placement": "bolt",
    purchase: "checkout",
    "set-product-index": "product",
    "set-state": "code"
};
export const sonner = {
    ...toast,
    propertyAction: (action, options)=>{
        const iconType = options?.iconType ?? "brand";
        const isEditor = iconType === "action";
        return toast(/*#__PURE__*/ _jsxs("div", {
            style: {
                display: "flex",
                alignItems: "center",
                gap: 12,
                ...options?.style
            },
            children: [
                /*#__PURE__*/ _jsx(SIcon, {
                    type: iconType === "brand" ? "logo-color" : actionIconMap[action.type],
                    className: iconType === "action" ? "text-brand-primary" : undefined,
                    size: iconType === "action" ? 16 : undefined
                }),
                /*#__PURE__*/ _jsxs("span", {
                    children: [
                        "Tap triggered a",
                        " ",
                        /*#__PURE__*/ _jsx(ToastPill, {
                            isEditor: isEditor,
                            margins: {
                                right: true
                            },
                            children: action.type
                        }),
                        action.type === "purchase" ? /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                "for",
                                action.reference.type === "by-index" ? /*#__PURE__*/ _jsx(ToastPill, {
                                    isEditor: isEditor,
                                    margins: {
                                        left: true
                                    },
                                    children: options?.referenceNames?.[action.reference.index] || 'unknown'
                                }) : /*#__PURE__*/ _jsx(ToastPill, {
                                    isEditor: isEditor,
                                    margins: {
                                        left: true
                                    },
                                    children: "selected"
                                })
                            ]
                        }) : /*#__PURE__*/ _jsx(_Fragment, {
                            children: "action"
                        }),
                        "."
                    ]
                })
            ]
        }));
    }
};
const ToastPill = ({ children, isEditor, margins })=>{
    return /*#__PURE__*/ _jsx("span", {
        style: {
            display: "inline-block",
            padding: isEditor ? "2px 6px" : "4px 6px",
            backgroundColor: "rgba(116, 255, 241, 0.15)",
            borderRadius: 7,
            color: "#74FFF1",
            textAlign: "center",
            marginRight: margins.right ? 4 : 0,
            marginLeft: margins.left ? 4 : 0
        },
        children: children
    });
};
